import { downloadImage } from '@/common/utils/downloadImage';
import { useState } from 'react';

const useDownloadExtension = ({ src }: { src: string }) => {
  const [loading, setLoading] = useState(false);
  const download = async () => {
    setLoading(true);
    await downloadImage(src);
    setLoading(false);
  };
  return { download, loading };
};

export default useDownloadExtension;
